import { useEffect, useState } from "react";
import { nanoid } from "@reduxjs/toolkit";
import { isEmpty } from "lodash";
import { useOutletContext } from "react-router-dom";
// components
import RMDRComponentSanitizer from "@/components/RMDRComponentSanitizer";
import MNPG050 from "@/components/MainPageLayouts/components/MNPG_050";
// hooks
import useContent from "@/hooks/useContent";
// types
import TOutletContext from "@/cms/types/TOutletContext";
// utilities
import { 
    innerLanguageVersion, 
    metaDataLanguageVersion
} from "@/utilities/LanguageVersionSelectorShortcut";
import RMDRImage from "@/components/RMDRImage";
import EResourceType from "@/cms/enums/EResourceType";


const unqKey = nanoid(12);
const Page404 = () => {
    console.log("Page404.rendered");

    const { siteSettingPayload, _showLoader, _hideLoader } = useOutletContext<TOutletContext>();
    const [ contentId ] = useState(metaDataLanguageVersion("404PageId", siteSettingPayload.languageVersions));
    const content = useContent({ unqKey, id:contentId });

    useEffect(
        () => {
            return () => { _showLoader(); }
        }, []
    )

    if ( !content || isEmpty(content) ) return null;

    _hideLoader();

    const languageVersion = innerLanguageVersion(content.languageVersions)

    return (
        <>
            <MNPG050 params={{contentDetails:content}} />
            <section className="section-padding-2 fix">
                <div className="container">
                    <div className="row justify-content-center">
                    <div className="col-lg-9">
                        <div className="error-items">
                            <div className="error-image">
                                <RMDRImage 
                                    resources={content.resources}
                                    resourceType={EResourceType.INNER_IMAGE}
                                    alt="404"
                                    title="404"
                                    disableLazyLoading
                                />
                            </div>
                            <RMDRComponentSanitizer 
                                languageVersion={languageVersion}
                                variant="div"
                                valueExpr="value"
                                removeTag
                            />
                        </div>
                    </div>
                    </div>
                </div>
            </section>
        </>
    )
}

export default Page404;
